import React, { useContext, useState } from 'react';
import CreateForm from '../../components/CreateForm';
import { PageContainer } from '../components/PageContainer';
import * as Yup from 'yup';
import { useHistory } from 'react-router-dom';
import { getDealerById, updateDealerById } from '../../services/usersServices';
export const UpdateDealer: React.FC<any> = (props): JSX.Element => {
  const history = useHistory();
  const [loading, setLoading] = useState<any>(false);
  const [form, setForm] = useState<any>({
    alias: {
      type: 'text',
      initialValue: '',
      name: 'alias',
      label: 'Alias',
      propsInput: {},
    },
    name: {
      type: 'text',
      initialValue: '',
      name: 'name',
      label: 'Name',
      propsInput: {},
    },
    profilePicture: {
      type: 'upload',
      initialValue: '',
      name: 'profilePicture',
      label: 'profilePicture',
      propsInput: {},
    },
    code: {
      type: 'text',
      initialValue: '',
      name: 'code',
      label: 'codigo',
      propsInput: {},
    },
    active: {
      type: 'switch',
      initialValue: true,
      name: 'active',
      label: 'Active',
      propsInput: {},
    },
  });
  const [validationSchema, setValidationSchema] = useState<any>(
    Yup.object().shape({
      alias: Yup.string().max(255).required('Se requiere un alias'),
      name: Yup.string().max(255).required('Se requiere un nombre'),
      code: Yup.string().max(255).required('Se requiere un codigo'),
    })
  );
  const onSubmit = async (
    values: any,
    { setErrors, setStatus, setSubmitting }: any
  ) => {
    try {
      let data = new FormData();
      data.append('profilePicture', values.profilePicture);
      data.append('alias', values.alias);
      data.append('name', values.name);
      data.append('code', values.code);
      data.append('active', values.active);
      setSubmitting(true);
      await updateDealerById(props.match.params.id, data);
      setStatus({ success: true });
      setSubmitting(false);
      history.push('/dealers');
    } catch (error) {
      const message = error.message || 'Algo salió mal. Intente nuevamente.';
      setStatus({ success: false });
      setErrors({ submit: message });
      setSubmitting(false);
    }
  };

  React.useEffect(() => {
    (async () => {
      let dealerUser: any = await getDealerById(props.match.params.id);
      if (dealerUser.status == 200) {
        dealerUser = dealerUser.data;
        setForm({
          ...Object.keys(form).reduce((acc: any, current: string) => {
            acc[current] = {
              ...form[current],
              initialValue: dealerUser[current],
            };
            return acc;
          }, {}),
        });
        setLoading(true);
      }
    })();

    return () => {};
  }, []);

  return (
    <PageContainer
      headerTitle="dealer"
      headerPath="/dealers"
      title={'Actualiza Dealer'}
      path="dealers/update/:id"
    >
      {loading ? (
        <CreateForm
          header={'Actualiza dealer'}
          description={'Utiliza esta herramienta para registrar nuevos dealers'}
          submitLabel={'Actualizar Usuario'}
          form={form}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        />
      ) : null}
    </PageContainer>
  );
};
